<template>
  <div class="home">
    <!-- Header -->
    <PhoneHeader @openForm="handleMenu"></PhoneHeader>
    <div class="container">
      <!-- 文章 -->
      <div class="article-box">
        <div class="article-title">
          {{ articleMessage.title }}
        </div>
        <div class="article-dateWatch">
          <div class="dateWatch-date">
            {{ articleMessage.releaseDate.slice(0, 10) }}&nbsp;&nbsp;{{
              articleMessage.releaseDate.slice(10, 18)
            }}
          </div>
          <div class="dateWatch-watch">
            <img src="../assets/img/frontierPhonePage/eye.png" />
            <span>{{ articleMessage.contentCount }}</span>
          </div>
        </div>
        <div class="box" v-show="isArticle">
          <div class="article-context" v-html="articleContent"></div>
          <div class="article-nextArticle" @click="contentExtByContentId">
            <span class="next">下一篇</span>
            <div class="articleName">
              {{ nextArticle.title ? nextArticle.title : nextArticle }}
            </div>
            <van-icon name="arrow" />
          </div>
        </div>
        <div v-show="!isArticle" style="display: flex; justify-content: center">
          <van-loading color="#1989fa" />
        </div>
      </div>
      <!-- 热门文章 -->
      <div class="article-hot">
        <div class="article-hot-title">热门文章</div>
        <div
          v-show="isArticleHot"
          v-for="(item, index) in articleHot"
          :key="item.id"
          @click="pushArticle(item, 291)"
        >
          <div class="article-hot-context">
            <div
              :class="{
                'article-hot-num': true,
                fontRed: index + 1 === 1,
                fontOrange: index + 1 === 2,
                fontYellow: index + 1 === 3,
              }"
            >
              {{ index + 1 }}
            </div>
            <div class="article-hot-text">{{ item.title }}</div>
          </div>
          <div class="divider">
            <van-divider />
          </div>
        </div>
        <div class="articleMore" @click="articleMore" v-show="isArticleHot">
          查看更多
        </div>
        <div
          v-show="!isArticleHot"
          style="display: flex; justify-content: center"
        >
          <van-loading color="#1989fa" />
        </div>
      </div>
    </div>
    <!-- 右侧菜单 -->
    <RightMenu
      :isMenuShow="isMenuShow"
      @rightMenuShow="handleRightMenuShow"
    ></RightMenu>
    <!-- 底部立即体验弹出 -->
    <ExperienceNow
      :isPopShow="isPopShow"
      @CloseExperienceNow="handleCloseExperienceNow"
    ></ExperienceNow>
    <!-- 公司信息 -->
    <CompanyInformation @changePracticeMenuShow="handleOpenPractice">
    </CompanyInformation>
    <!-- Footer -->
    <PhoneFooter @handleFooter="handleOpenPractice"></PhoneFooter>
  </div>
</template>
<script>
import PhoneHeader from "./include/PhoneHeader";
import PhoneFooter from "./include/PhoneFooter";
import RightMenu from "./include/RightMenu";
import ExperienceNow from "./include/ExperienceNow";
import CompanyInformation from "./include/CompanyInformation";
import { getArticleContent } from "../api/casePage";
import { contentExtByContentId, getContentInfo } from "../api/frontierPage";
export default {
  name: "FrontierPhonePage",
  components: {
    PhoneHeader,
    PhoneFooter,
    RightMenu,
    ExperienceNow,
    CompanyInformation,
  },
  data() {
    return {
      isPopShow: false, // 立即体验弹窗
      isMenuShow: false, // 顶部菜单栏
      articleContent: "", // 文章内容
      articleMessage: "", // 文章信息
      articleHot: "", // 热门文章
      isArticle: false, // 文章loading
      isArticleHot: false, // 热门文章loading
      nextArticle: "", // 下篇文章
      // 热门文章表单
      hotArticleData: {
        channelId: 291,
        pageSize: 5,
        sort: "contentCount",
        pageNo: 1,
      },
    };
  },
  watch: {},
  methods: {
    // 刷新页面
    refresh() {
      window.location.reload();
      window.scrollTo({ top: 0 });
    },
    // 打开右侧菜单弹窗
    handleMenu() {
      this.isMenuShow = true;
    },
    // 关闭右侧菜单弹窗
    handleRightMenuShow() {
      this.isMenuShow = false;
    },
    // 打开立即体验弹窗
    handleOpenPractice() {
      this.isPopShow = true;
    },
    // 关闭立即体验弹窗
    handleCloseExperienceNow() {
      this.isPopShow = false;
    },
    // 获取文章内容
    getArticleMessage() {
      const self = this;
      const articleInfo = JSON.parse(localStorage.getItem("article"));
      self.articleMessage = articleInfo;
      if (articleInfo.id) {
        getArticleContent(Number(articleInfo.id))
          .then((res) => {
            self.articleContent = res.data;
            self.isArticle = true;
          })
          .catch((error) => {
            self.isArticle = false;
            self.$message.error("未获取到文章内容!");
          });
      } else {
        self.$message.warning("未获取到文章内容！");
      }
      // 获取当前文章的上下篇文章
      let storage = new FormData();
      let contentId = self.articleMessage.id;
      let channelId = self.articleMessage.channelId;
      storage.append("contentId", Number(contentId));
      storage.append("channelId", Number(channelId));
      contentExtByContentId(storage).then((res) => {
        if (res.status === 200) {
          if (res.data.length === 2) {
            let index = res.data.findIndex((item) => {
              return item.id === contentId;
            });
            if (index + 1 !== 2) {
              self.nextArticle = res.data[index + 1];
              self.nextArticle.channelId = self.articleMessage.channelId;
            } else {
              self.nextArticle = "没有了";
            }
          } else {
            let index = res.data.findIndex((item) => {
              return item.id === contentId;
            });
            self.nextArticle = res.data[index + 1];
            self.nextArticle.channelId = self.articleMessage.channelId;
          }
        }
      });
    },
    // 跳转下一篇信息
    contentExtByContentId() {
      const self = this;
      if (self.nextArticle !== "没有了") {
        localStorage.setItem("article", JSON.stringify(self.nextArticle));
        self.refresh();
      }
    },
    // 获取热门文章
    getContentInfo_channelId() {
      const self = this;
      getContentInfo(self.hotArticleData).then((res) => {
        if (res.status === 200) {
          self.articleHot = res.data.content.map((item, index) => {
            return { ...item, channelId: 291 }; // 添加栏目id
          });
          self.isArticleHot = true;
        } else {
          self.isArticleHot = false;
        }
      });
    },
    // 打开文章
    pushArticle(article, id) {
      let articleMessage = article;
      articleMessage.channelId = id;
      localStorage.setItem("article", JSON.stringify(articleMessage));
      this.refresh();
    },
    // 查看更多
    articleMore() {
      this.$router.push({
        name: "FrontierPhonePage",
      });
    },
  },
  mounted() {},
  created() {
    this.getArticleMessage();
    this.getContentInfo_channelId();
  },
};
</script>
<style scoped>
/* 文章 */
.container {
  padding: 53px 20px 20px 20px;
}
.article-box {
  min-height: 500px;
  margin-top: 20px;
}
.article-title {
  font-size: 0.4rem;
  font-weight: 600;
  line-height: 30px;
}
.article-dateWatch {
  display: flex;
  align-items: center;
  padding: 10px 0;
}
.dateWatch-watch {
  display: flex;
  align-items: center;
  margin-left: 20px;
}

.dateWatch-watch > img {
  width: 17px;
  height: 11px;
}
.dateWatch-watch > span {
  font-size: 15px;
  color: #a7a7a7;
  margin-left: 3px;
}
.dateWatch-date {
  font-size: 15px;
  color: #a7a7a7;
}
.article-nextArticle {
  display: flex;
  justify-content: space-between;
  padding: 25px 20px;
  font-size: 15px;
  align-items: center;
  background: #f5f6fa;
}
.article-nextArticle .next {
  color: #a7a7a7;
}
.article-nextArticle .articleName {
  color: #2e2e2e;
  font-weight: 500;
  overflow: hidden;
  line-height: 30px;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin: 0 15px;
  width: 65%;
}

/* 文章end */
/* 热门文章 */
.article-hot {
  margin-top: 20px;
}
.article-hot-title {
  font-size: 22px;
  margin: 20px 0px;
  font-weight: 600;
}
.article-hot-context {
  display: flex;
  align-items: center;
  justify-content: left;
  line-height: 35px;
}
.article-hot-num {
  font-size: 16px;
}
.article-hot-text {
  font-size: 15px;
  margin-left: 10px;
  overflow: hidden;
  line-height: 30px;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.fontRed {
  color: #e93131;
}
.fontOrange {
  color: #fea521;
}
.fontYellow {
  color: #e6c908;
}
.divider {
  display: flex;
  justify-content: center;
}
.divider > .van-divider {
  margin: 5px 0;
  width: 100%;
}
.articleMore {
  display: flex;
  justify-content: center;
  padding-top: 15px;
  font-size: 16px;
  color: #186cf5;
}
/* 热门文章end */
</style>


// WEBPACK FOOTER //
// src/components/FrontierDetailsPhoneArticle.vue